import ICustomer from "./ICustomer";
import IBlock1 from "./IBlock1";
import Block1 from "./Block1";
import IBlock2Income from "./IBlock2Income";
import Block2Income from "./Block2Income";
import IBlock2Others from "./IBlock2Others";
import Block2Others from "./Block2Others";
import IBlock3Others from "./IBlock3Others";
import Block3Others from "./Block3Others";
import IBlock3Address from "./IBlock3Address";
import Block3Address from "./Block3Address";
import IBlock3Employee from "./IBlock3Employee";
import Block3Employee from "./Block3Employee";
import IBlock3Entrepreneur from "./IBlock3Entrepreneur";
import Block3Entrepreneur from "./Block3Entrepreneur";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import FinancedSubjectTypeEnum from "@/module/main/dto/FinancedSubjectTypeEnum";
import IOrderItem from "@/module/main/model/applicationForm/IOrderItem";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import Broker from "@/module/main/model/applicationForm/Broker";
import IBroker from "@/module/main/model/applicationForm/IBroker";
import Entrepreneur from "@/module/main/model/applicationForm/Entrepreneur";
import IEntrepreneur from "@/module/main/model/applicationForm/IEntrepreneur";
import ClientType from "@/module/main/dto/ClientTypeEnum";
import ICarLoan from "./ICarLoan";
import CarLoan from "./CarLoan";

export default class Customer implements ICustomer {
    constructor(
        public block1: IBlock1 = new Block1({}),
        public block2Income: IBlock2Income = new Block2Income(),
        public block2Others: IBlock2Others = new Block2Others(),
        public block3Others: IBlock3Others = new Block3Others(),
        public block3Address: IBlock3Address = new Block3Address(),
        public block3Employee: IBlock3Employee = new Block3Employee(),
        public block3Entrepreneur: IBlock3Entrepreneur = new Block3Entrepreneur(),
        public orderItems: IOrderItem[] = [],
        public financedSubjectType: FinancedSubjectType = FinancedSubjectTypeEnum.CASH,
        public orderType: OrderType = OrderType.STANDARD,
        public clientType: ClientType = ClientType.PERSON,
        public broker: IBroker = new Broker(),
        public entrepreneur: IEntrepreneur = new Entrepreneur(),
        public carLoan: ICarLoan = new CarLoan(),
    ) {
    }
}
